<template>
  <Card :pt="BikeCardPreset">
    <template #header>
      <Skeleton width="100%" height="250px" />
    </template>
    <template #title>
      <Skeleton class="mb-2" height="2rem" width="70%" />

    </template>
    <template #content>
      <div class="space-y-1">
        <Skeleton class="mb-2" width="80%" />
        <Skeleton class="mb-2" width="75%" />
        <Skeleton class="mb-2" width="70%" />
      </div>
      <hr class="border-primary-100 my-4" />
      <Skeleton class="mb-2" width="100%" />
      <Skeleton class="mb-2" width="100%" />
      <Skeleton class="mb-2" width="60%" />
      <Skeleton class="mb-2" width="70%" />
    </template>
  </Card>
</template>

<script lang="ts" setup>
import Card from "primevue/card";
import BikeCardPreset from '@/presets/o2o/BikeCard'
import Skeleton from "primevue/skeleton";
</script>